import { CRUDApiService } from "./CRUDApiService";

export class CapsulesApiService extends CRUDApiService {
  constructor() {
    super('capsules');
  }
}
